import { createContext, useContext } from 'react';

interface NavMenuContextValue {
  closeMenu: () => void;
}

const NavMenuContext = createContext<NavMenuContextValue>({ closeMenu: () => {} });

export const NavMenuProvider = NavMenuContext.Provider;

export const useNavMenu = () => useContext(NavMenuContext);
